import { Bed, Calendar } from 'lucide-react';
import type { Booking } from '@/types/booking.types';
import type { Room } from '@/types/room.types';

interface ReservationStaySectionProps {
  booking: Booking | undefined;
  allocatedRoom: Room | null;
  allocatedRoomId: number | null | undefined;
  nights: number;
}

export function ReservationStaySection({
  booking,
  allocatedRoom,
  allocatedRoomId,
  nights,
}: ReservationStaySectionProps) {
  return (
    <section className="space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
        Estadia
      </h3>
      <div className="grid grid-cols-2 gap-3">
        <DateCard
          tone="text-emerald-400"
          label="Check-in"
          value={booking?.arrival_date}
          time="14:00"
        />
        <DateCard
          tone="text-blue-400"
          label="Check-out"
          value={booking?.departure_date}
          time="12:00"
        />
      </div>
      <div className="glass rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-violet-500/20 flex items-center justify-center">
              <Bed className="w-5 h-5 text-violet-400" />
            </div>
            <div>
              <p className="font-semibold">
                {allocatedRoom
                  ? `Quarto ${allocatedRoom.number}`
                  : allocatedRoomId != null
                    ? `Quarto #${allocatedRoomId}`
                    : 'Quarto não alocado'}
              </p>
              <p className="text-sm text-muted-foreground">{booking?.source ?? '-'}</p>
            </div>
          </div>
          <div className="text-right">
            <p className="text-lg font-semibold">{nights} noites</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function DateCard({
  tone,
  label,
  value,
  time,
}: {
  tone: string;
  label: string;
  value: string | undefined;
  time: string;
}) {
  return (
    <div className="glass rounded-xl p-4">
      <div className={`flex items-center gap-2 ${tone} mb-2`}>
        <Calendar className="w-4 h-4" />
        <span className="text-xs font-medium uppercase">{label}</span>
      </div>
      <p className="text-lg font-semibold">
        {value
          ? new Date(value).toLocaleDateString('pt-BR', {
              day: '2-digit',
              month: 'short',
            })
          : '-'}
      </p>
      <p className="text-xs text-muted-foreground">{time}</p>
    </div>
  );
}
